import React, { forwardRef } from "react";
import {Fade} from "react-awesome-reveal"
import ExperienceCard from "./ExperienceCard/ExperienceCard";
import html from "../../images/html.png";
import js from "../../images/javascript.png";
import react from "../../images/react.png";
import blender from "../../images/blender.png";
import canva from "../../images/canva.png";
import figma from "../../images/figma.png";
import python from "../../images/python.png";
import pytorch from "../../images/pytorch.png";
import tensorflow from "../../images/tensorflow.png";
import deep from "../../images/deep learning.png";
import css from "../../images/css.png";

const Experience = forwardRef((props, ref) => {
  const statements = [
    <li>Created various UI/UX designs on Figma like UI for Starbucks corporations, food delivery services</li>,
    <li>Developed 3D models of biological species like liver fluke, leaves, nephron, tubules, etc.</li>,
    <li>Created many posters on metaverse, virtual reality, etc.</li>,
  ];
  const iconImages = [react, js, html, css, figma, canva, blender];


  const statements2 = [
    <li>Used pre-trained models (DALL-E-mini, Stable Diffusion) to generate images from text prompts.</li>,
    <li>Created a text generation algorithm using Markov chains.</li>,
    <li> Trained GPT-2 to generate contextually relevant text based on prompts.</li>,
  ];
  
  const iconImages2 = [deep,python,pytorch,tensorflow];

  return (
    <div ref={ref} id="experience" className="experience_container">    
    <Fade  direction="up" triggerOnce>

      <p className="m-5 text-4xl mb-0 font-bold text-center">Experience</p>
      <div className=" flex flex-wrap height-auto py-10 flex gap-0">
      <ExperienceCard
          companyName="Prodigy Infotech Pvt. Ltd.  "
          designation="Gen AI Intern"
          statements={statements2}
          iconImages={iconImages2}
        />
        <ExperienceCard
          companyName="Astomverse Innovations Pvt. "
          designation="SDE Intern"
          statements={statements}
          iconImages={iconImages}
        />
      </div></Fade>
    </div>
  );
});

export default Experience;
